// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"69a85805","885":"6531caa6"}[chunkId] + ".chunk.js";
};